import service from "./service";

export const findAll = listQuery => {
  return service.get("/v1/manufacture", listQuery);
};

export const findWidthProduct = (
  orderId,
  orderDetailId,
  productId,
  productSpecifyId,
  colorId
) => {
  return service.get(`/v1/manufacture/product`, {
    orderId,
    orderDetailId,
    productId,
    productSpecifyId,
    colorId
  });
};

export const findOne = id => {
  return service.get(`/v1/manufacture/${id}`);
};

export const update = (id, data) => {
  return service.post(`/v1/manufacture/${id}`, data);
};

export const create = (
  manufacture,
  manufactureFeatures,
  manufactureParameters
) => {
  return service.post(`/v1/manufacture`, {
    manufacture,
    manufactureFeatures,
    manufactureParameters
  });
};

export const verify = id => {
  return service.post(`/v1/manufacture/${id}/verify`);
};

export const status = (id, status, quantityProduce) => {
  return service.post(`/v1/manufacture/${id}/status`, {
    status,
    quantityProduce
  });
};

export const removeList = list => {
  return service.post(`/v1/manufacture/deletes`, { list });
};
